import { CMP_TYPOGRAPHY_UI_TABLE_TITLE, SEM_TYPOGRAPHY_UI_MD_COPY, SEM_TYPOGRAPHY_UI_MD_HEADLINE, SYS_BREAKPOINT_MD, SYS_SIZE_FIXED_25, SYS_SIZE_FIXED_50, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_25, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_50, getTypographyStyles } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import {} from './index.js';
const getDisplayStyle = (displayMode, tableStyle, listStyle, autoStyle) => {
    if (displayMode === 'auto')
        return autoStyle;
    if (displayMode === 'table')
        return tableStyle;
    return listStyle;
};
export const StyledTableHead = styled.thead ``;
export const StyledTableRow = styled.tr ``;
export const StyledTableBody = styled.tbody ``;
export const StyledCaption = styled.caption `
  text-align: start;
  ${getTypographyStyles(CMP_TYPOGRAPHY_UI_TABLE_TITLE)}
  color: ${(props) => props.theme.cmp.color.ui.table.foreground.text.title.default};
  padding: 0 0 ${SYS_SPACE_FIXED_300} 0;
`;
export const StyledTableColumnHeadingCell = styled.th `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_HEADLINE)}
  font-weight: bold;
  text-align: start;
  vertical-align: top;
  padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300};
  color: ${(props) => props.theme.cmp.color.ui.table.foreground.text.headline.default};
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: ${(props) => props.$width && props.$width};
  }
`;
export const StyledTableRowHeadingCell = styled.th `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_HEADLINE)}
  font-weight: bold;
  text-align: start;
  vertical-align: top;
  padding: ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_200};
  color: ${(props) => props.theme.cmp.color.ui.table.foreground.text.headline.default};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: ${(props) => props.$width && props.$width};
    padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300};
  }
`;
export const StyledColumnHeading = styled.div `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_HEADLINE)}
  font-weight: bold;
  margin-bottom: ${SYS_SPACE_FIXED_100};
`;
export const StyledTableCell = styled.td `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_COPY)}
  color: ${(props) => props.theme.cmp.color.ui.table.foreground.text.copy.default};
  padding: ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_100};
  vertical-align: top;

  &:not(:last-child) {
    margin-bottom: ${SYS_SPACE_FIXED_50};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: ${(props) => props.$width && props.$width};
    padding: ${SYS_SPACE_FIXED_150} 0 ${SYS_SPACE_FIXED_300};
  }
`;
export const StyledTable = styled.table `
  display: ${(props) => getDisplayStyle(props.displayMode, 'table', 'block', 'block')};
  width: 100%;
  border-spacing: ${SYS_SPACE_FIXED_100} 0;
  border-collapse: separate;

  ${StyledTableRow}:first-child {
    ${StyledTableCell} {
      border-top: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
    }
  }

  ${StyledTableBody} {
    &:has(${StyledTableRowHeadingCell}) {
      ${StyledTableRow}:first-child {
        ${StyledTableCell} {
          border-top: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_50} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};

          @media (min-width: ${SYS_BREAKPOINT_MD}) {
            border-top: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SIZE_FIXED_50} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
          }
        }
      }
    }
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: ${(props) => getDisplayStyle(props.displayMode, 'table', 'block', 'table')};

    ${StyledTableRow}:first-child {
      ${StyledTableCell} {
        border-top: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
      }
    }
  }

  ${StyledTableHead} {
    display: ${(props) => getDisplayStyle(props.displayMode, 'table-header-group', 'none', 'none')};

    ${StyledTableRow}:first-child {
      ${StyledTableCell} {
        border-top: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SIZE_FIXED_50} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
        border-bottom: none;
      }
    }

    & + ${StyledTableBody} {
      ${StyledTableRow} {
        &:first-child {
          ${StyledTableRowHeadingCell} {
            border-top: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
          }
        }
      }

      &:has(${StyledTableRowHeadingCell}) {
        ${StyledTableRow}:first-child {
          ${StyledTableCell} {
            border-top: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
          }
        }
      }
    }

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: ${(props) => getDisplayStyle(props.displayMode, 'table-header-group', 'none', 'table-header-group')};

      &:has(${StyledTableCell}) {
        + ${StyledTableBody} {
          ${StyledTableRow}:first-child {
            ${StyledTableRowHeadingCell}, ${StyledTableCell} {
              border-top: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
            }
          }
        }
      }
    }
  }

  ${StyledTableRow} {
    display: ${(props) => getDisplayStyle(props.displayMode, 'table-row', 'block', 'block')};

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: ${(props) => getDisplayStyle(props.displayMode, 'table-row', 'block', 'table-row')};
    }
  }

  :has(${StyledTableHead}) {
    ${StyledTableRow} {
      ${StyledTableRowHeadingCell} {
        & ~ ${StyledTableCell} {
          padding: ${(props) => props.displayMode !== 'table'
    ? `0px 0px ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_200}`
    : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};

          &:last-child {
            padding: ${(props) => props.displayMode !== 'table'
    ? `0px 0px calc(${SYS_SPACE_FIXED_100} + ${SYS_SPACE_FIXED_100}) ${SYS_SPACE_FIXED_200}`
    : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};
          }

          @media (min-width: ${SYS_BREAKPOINT_MD}) {
            padding: ${(props) => props.displayMode !== 'list' &&
    `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};

            &:last-child {
              padding: ${(props) => props.displayMode !== 'list' &&
    `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};
            }
          }
        }
      }
    }
  }

  ${StyledTableRow} {
    ${StyledTableRowHeadingCell} {
      & ~ ${StyledTableCell} {
        padding: ${(props) => props.displayMode !== 'table'
    ? `0  ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_150}`
    : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};
        &:last-child {
          padding: ${(props) => props.displayMode !== 'table' &&
    `0  ${SYS_SPACE_FIXED_50} calc(${SYS_SPACE_FIXED_150} + ${SYS_SPACE_FIXED_25} + ${SYS_SPACE_FIXED_50})`};
        }

        @media (min-width: ${SYS_BREAKPOINT_MD}) {
          padding: ${(props) => props.displayMode !== 'list' &&
    `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};
          &:last-child {
            padding: ${(props) => props.displayMode !== 'list' &&
    `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};
          }
        }
      }
    }
  }

  ${StyledTableRow} {
    ${StyledTableRowHeadingCell} {
      padding: ${(props) => props.displayMode !== 'table'
    ? `${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_200}`
    : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};

      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        padding: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`
    : `${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_200}`};
      }
    }
  }

  ${StyledTableCell} {
    display: ${(props) => getDisplayStyle(props.displayMode, 'table-cell', 'block', 'block')};
    border-bottom: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
    padding: ${(props) => props.displayMode !== 'table'
    ? `${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_100};`
    : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      padding: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`
    : `${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_100}`};
    }

    &:last-child {
      border-bottom: ${SYS_SIZE_FIXED_25} solid
        ${(props) => props.theme.cmp.color.ui.table.foreground.divider.default};
      padding: ${(props) => props.displayMode !== 'table'
    ? `${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} calc(${SYS_SPACE_FIXED_100} + ${SYS_SPACE_FIXED_100});`
    : `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`};

      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        padding: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_300}`
    : `${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_50} calc(${SYS_SPACE_FIXED_100} + ${SYS_SPACE_FIXED_100});`};
      }
    }

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: ${(props) => getDisplayStyle(props.displayMode, 'table-cell', 'block', 'table-cell')};

      border-bottom: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
    }
  }

  ${StyledTableBody} {
    display: ${(props) => getDisplayStyle(props.displayMode, 'table-row-group', 'block', 'block')};

    border-top: ${(props) => props.displayMode !== 'table'
    ? `${SYS_SIZE_FIXED_50} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: ${(props) => getDisplayStyle(props.displayMode, 'table-row-group', 'block', 'table-row-group')};
    }
  }

  ${StyledColumnHeading} {
    display: ${(props) => getDisplayStyle(props.displayMode, 'none', 'block', 'block')};

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: ${(props) => getDisplayStyle(props.displayMode, 'none', 'block', 'none')};
    }
  }

  ${StyledCaption} {
    display: ${(props) => getDisplayStyle(props.displayMode, 'table-caption', 'block', 'block')};

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: ${(props) => getDisplayStyle(props.displayMode, 'table-caption', 'block', 'table-caption')};
    }
  }

  ${StyledTableColumnHeadingCell} {
    border-top: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_50} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      border-top: ${SYS_SIZE_FIXED_50} solid
        ${(props) => props.theme.cmp.color.ui.table.foreground.divider.default};
    }
  }

  ${StyledTableRowHeadingCell} {
    display: ${(props) => getDisplayStyle(props.displayMode, 'table-cell', 'block', 'block')};

    border-bottom: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
  }

  ${StyledTableRow} {
    &:first-child {
      ${StyledTableRowHeadingCell} {
        border-top: ${(props) => props.displayMode === 'table'
    ? `${SYS_SIZE_FIXED_50} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};

        @media (min-width: ${SYS_BREAKPOINT_MD}) {
          border-top: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SIZE_FIXED_50} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
        }
      }
    }
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    ${StyledTableRowHeadingCell} {
      display: ${(props) => getDisplayStyle(props.displayMode, 'table-cell', 'block', 'table-cell')};

      border-bottom: ${(props) => props.displayMode !== 'list'
    ? `${SYS_SIZE_FIXED_25} solid ${props.theme.cmp.color.ui.table.foreground.divider.default}`
    : 'none'};
    }
  }
`;
//# sourceMappingURL=index.styles.js.map